//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";

export default {
    name: "AddProcessModal",
    components: {
        AQDialog,
        AQUploader
    },
    data() {
        return {
            importApp: true,
            fileImportedApp: null,
            importDialogBtn: true,
            showDuplicatedAppDialog: false
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"])
    },
    mounted() {
        document.addEventListener("keydown", this.onKeyDown, false);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.onKeyDown, false);
    },
    methods: {
        ...mapActions("apps", ["importApplication", "checkDuplicatedApplication"]),
        importAppMth() {
            this.importDialogBtn = true;
            if (this.fileImportedApp) {
                const formDataImport = new FormData();
                formDataImport.append("file", this.fileImportedApp);
                const dataToSend = formDataImport;
                this.importApplication(dataToSend).then(data => {
                    if (data.data.catalogsWarning) {
                        this.$toast.showNotify({
                            message: data.data.catalogsWarning,
                            type: "warning"
                        });
                    }
                    this.importApp = false;
                    const copyOfImportedAppRsp = data.data;
                    copyOfImportedAppRsp.publishStatus = "UNPUBLISHED_CHANGES";
                    this.$store.commit("apps/setCurrentApp", copyOfImportedAppRsp);
                    this.$store.commit("main/setCurrentApplicationId", data.data.id);
                    this.$store.dispatch("admin/getRoleList");
                    this.$backendWebsocketEvents.startWebsocket(data.data.id);
                    this.$emit("resetImportModal");
                    this.importDialogBtn = false;
                    this.$router.push(`/applications/${data.data.id}/processes`);
                }).catch(() => {
                    this.importDialogBtn = false;
                    this.$emit("resetImportModal");
                });
            } else {
                this.importApp = true;
            }
        },
        checkDuplicatedApp() {
            this.importApp = true;
            if (this.fileImportedApp) {
                const formDataImport = new FormData();
                formDataImport.append("file", this.fileImportedApp);
                const dataToSend = formDataImport;
                this.checkDuplicatedApplication(dataToSend).then(rsp => {
                    if (rsp.data) {
                        this.importAppMth();
                    } else {
                        this.showDuplicatedAppDialog = true;
                    }
                    this.importApp = false;
                }).catch(() => {
                    this.importApp = false;
                });
            }
        },
        onAppImportSelected(appImported) {
            if (appImported && appImported.length) {
                [this.fileImportedApp] = appImported;
                this.importDialogBtn = false;
            } else {
                this.removeFile();
            }
        },
        removeFile() {
            this.fileImportedApp = null;
            this.importDialogBtn = true;
        },
        onKeyDown(ev) {
            if (ev.keyCode === 27) {
                this.importApp = false;
                this.$emit("resetImportModal");
            }
        }
    }
};
